module.exports = __webpack_public_path__ + "static/media/link-arrow-plain.510f5acb.svg";